<template>
  <b-row>
    <b-col cols="3" class="pr-0">
      <b-input-group prepend="Crop Type">
        <b-select
          v-model="projection.crop"
          :options="options"
          invalid-feedback="Required"
          :state="!$v.projection.crop.$invalid"
          @change="(e) => handleCropUpdate(e, projection)"
        />
      </b-input-group>
    </b-col>
    <b-col cols="4" class="pr-0">
      <b-input-group prepend="Yield Desired">
        <b-form-input
          v-model.number="projectionYield"
          type="number"
          invalid-feedback="Required"
          :state="!$v.projectionYield.$invalid"
        />
      </b-input-group>
    </b-col>
    <b-col cols="3">
      <b-input-group prepend="Unit">
        <b-form-input disabled v-model="projection.unit" />
      </b-input-group>
    </b-col>
    <b-col class="px-0">
      <b-button-group>
        <b-button
          v-if="projectionListLength === +index + 1"
          variant="success"
          @click="addProjection"
        >
          <i class="fa fa-plus" />
        </b-button>
        <b-button
          v-if="projectionListLength > 1"
          variant="danger"
          @click="removeProjection"
        >
          <i class="fa fa-trash" />
        </b-button>
      </b-button-group>
    </b-col>
  </b-row>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";

export default {
  name: "ProjectSoilCropForm",
  mixins: [validationMixin, ToastNotifications],
  props: {
    projection: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
    projectionListLength: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    projectionYield: {
      get() {
        return this.projection.yield;
      },
      set(value) {
        this.$emit("updateYield", value, this.index);
      },
    },
  },
  validations: {
    projection: {
      crop: {  },
    },
    projectionYield: {  },
  },
  methods: {
    handleCropUpdate(e, projection) {
      this.$emit("cropUpdate", e, projection);
    },
    addProjection() {
      this.$emit("updateProjectionList");
    },
    removeProjection() {
      this.$emit("updateProjectionList", this.index);
    },
  },
};
</script>
